import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { addVehicle, getVehicleInfo } from '../../../../actions/formAction';
import { Form, Formik } from 'formik';
import { Alert, AlertTitle, Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Typography,  Dialog as MuiDialog, TextareaAutosize, } from '@mui/material';
import Progress from '../../../../components/Loader/Progress ';
import CloseIcon from "@mui/icons-material/Close";
import SaveIcon from "@mui/icons-material/Save";


function DividerSP({ title  }) {
  return (
    <Box sx={{ pt: 2 }}>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 2 }}>
        <Box
          sx={{
            backgroundColor: "#d32f2f",
            width: 11,
            height: 24,
            borderRadius: 1,
          }}
        />
        <Typography variant="subtitle1" fontWeight="bold">
          {title}
        </Typography>
      </Box>
    </Box>
  );
}

function CancelledOrReturnedModal({ isOpen, onClose, vehicleId   }) {
    const [initialValues, setInitialValues] = useState({});
      const [showConfirm, setShowConfirm] = useState(false);
      const vehicleInfo = useSelector((state) => state.vehicleInfo);
      const add = useSelector((state) => state.add);
    
      const dispatch = useDispatch();
    
      useEffect(() => {
        if (isOpen) {
          dispatch(getVehicleInfo({ vehicleId }));
        }
      }, [dispatch, isOpen, vehicleId]);
    
      useEffect(() => {
        if (vehicleInfo.loading === "succeeded") {
          setInitialValues(vehicleInfo.Object);
          setInitialValues((prevValues) => ({
            ...prevValues,
            status: { id: 4 }, // Assuming 4 is the ID for "Cancelled or Returned"
          }));
        }
      }, [vehicleInfo]);
    
      const hasFormErrors = (formik) => {
        return Object.keys(formik.errors).length > 0;
      };
    
     
    
      // Simulate save logic
      const handleSave = async (values, actions) => {
        await dispatch(addVehicle({ data: values, id: vehicleId }));
        
      };
    
      useEffect(() => {
        if (add.vehicleAddedSuccessfully) {
          setShowConfirm(false);
          onClose();
        }
    
        if (add.hasError) {
          setShowConfirm(false);
        }
      }, [ add.hasError, onClose, add.vehicleAddedSuccessfully]);



  return (
     <Formik
      initialValues={initialValues}
      enableReinitialize
      onSubmit={handleSave}
    >
      {(formik) => (
        <Form>
          <Dialog
            open={isOpen}
            onClose={add.isLoading ? undefined : onClose}
            maxWidth="sm"
            fullWidth
            disableEscapeKeyDown={add.isLoading}
            disableBackdropClick={add.isLoading}
          >
            <DialogTitle
              sx={{ fontWeight: "bold", pr: 5, position: "relative" }}
            >
              Cancelled or Returned Vehicle
              <Button
                aria-label="close"
                onClick={onClose}
                sx={{
                  position: "absolute",
                  right: 8,
                  top: 8,
                  color: (theme) => theme.palette.grey[500],
                  minWidth: 0,
                  padding: 0,
                }}
              >
                <CloseIcon />
              </Button>
            </DialogTitle>
            <DialogContent>
              {vehicleInfo.loading === "pending" ||
              vehicleInfo.loading === "idle" ? (
                <Progress Msg="Loading vehicle information..." />
              ) : vehicleInfo.loading === "failed" ? (
                <Alert severity="error">
                  Error loading vehicle information.
                </Alert>
              ) : (
                <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
                  <Box
                    sx={{
                      background: "#f7fafd",
                      borderRadius: 2,
                      p: 2,
                      mb: 2,
                      boxShadow: "0 1px 4px #0001",
                    }}
                  >
                    <DividerSP title="Vehicle Information" />
                    <Typography variant="body1" sx={{ mb: 0.5 }}>
                      Client: {formik.values?.client?.name || "-"}
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 0.5 }}>
                      Vehicle: {formik.values?.year} {formik.values?.make?.name}{" "}
                      {formik.values?.model?.name}{" "}
                      {formik.values?.vehicleType?.name}
                    </Typography>
                    <Typography variant="body1" sx={{ mb: 0 }}>
                      VIN: {formik.values?.vin || "-"}
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      background: "#fff",
                      borderRadius: 2,
                      p: 2,
                      boxShadow: "0 1px 4px #0001",
                    }}
                  >
                    <DividerSP title="Notes" />

                    <TextareaAutosize
                      name="cancellationNote"
                      style={{
                        background: "#fff",
                        minHeight: "90px",
                        width: "100%",
                        border: "1px solid #D9DCE1",
                        borderRadius: "8px",
                        padding: "10px",
                        resize: "none",
                        fontFamily: "inherit",
                        fontSize: 15,
                      }}
                      placeholder={"Cancellation Note (optional)"}
                      value={formik.values.cancellationNote || ""}
                      onChange={formik.handleChange}
                    />
                    
                  </Box>
                </Box>
              )}
            </DialogContent>

            <DialogActions
              sx={{
                p: 2,
                flexDirection: "column-reverse",
                gap: 2,
                alignItems: "flex-end", // Align content to the right
              }}
            >
              {add.hasError && (
                <Box className="errorBox" sx={{ width: "100%" }}>
                  <Alert severity="error">
                    <AlertTitle>Error</AlertTitle>
                    {add.hasError ? <div>{add.errorMessage}</div> : ""}
                  </Alert>
                </Box>
              )}

              <Box sx={{ width: "100%", display: "flex", justifyContent: "flex-end" }}>
                <Button
                  color="primary"
                  variant="b1"
                  startIcon={<SaveIcon />}
                  disabled={formik.isSubmitting}
                  onClick={async () => {
                    await formik.validateForm();
                    setShowConfirm(true);
                  }}
                >
                  Save
                </Button>
              </Box>
            </DialogActions>
          </Dialog>
          <MuiDialog
            open={showConfirm}
            onClose={add.isLoading ? undefined : () => setShowConfirm(false)}
            disableEscapeKeyDown={add.isLoading}
            disableBackdropClick={add.isLoading}
          >
            <DialogTitle>Save Confirmation</DialogTitle>
            <DialogContent>
              {hasFormErrors(formik) ? (
                <Box className="errorBox">
                  <Alert severity="error">
                    <AlertTitle>Error</AlertTitle>
                    {Object.keys(formik.errors).map((fieldName, index) => {
                      if (Array.isArray(formik?.errors[fieldName])) {
                      } else {
                        return (
                          <div key={index}>{formik.errors[fieldName]}</div>
                        );
                      }
                    })}
                  </Alert>
                </Box>
              ) : (
                <DialogContentText>
                  Are you sure you want to move this vehicle to <strong>Cancelled or Returned</strong> status with the following information?
                  <br />
                  <strong>Client:</strong> {formik.values?.client?.name || "-"}
                  <br />
                  <strong>Vehicle:</strong> {formik.values?.year}{" "}
                  {formik.values?.make?.name} {formik.values?.model?.name}{" "}
                  {formik.values?.vehicleType?.name}
                  <br />
                  <strong>VIN:</strong> {formik.values?.vin || "-"}
                </DialogContentText>
              )}
            </DialogContent>
            <DialogActions>
              <Button onClick={() => setShowConfirm(false)} color="secondary">
                Cancel
              </Button>
              {!add.isLoading ? (
                <Button
                  onClick={() =>
                    hasFormErrors(formik)
                      ? setShowConfirm(false)
                      : formik.submitForm()
                  }
                  color="primary"
                  variant={hasFormErrors(formik) ? "b2" : "b1"}
                  startIcon={
                    hasFormErrors(formik) ? <CloseIcon /> : <SaveIcon />
                  }
                  disabled={formik.isSubmitting}
                >
                  {hasFormErrors(formik) ? "Close" : "Confirm Arrival"}
                </Button>
              ) : (
                <Progress Msg="Saving..." />
              )}
            </DialogActions>
          </MuiDialog>
        </Form>
      )}
    </Formik>
  )
}

export default CancelledOrReturnedModal